'use client'

import { AnimatePresence, motion } from 'framer-motion'
import { usePathname } from 'next/navigation'
import { FC, ReactNode } from 'react'
import FrozenRoute from './FrozenRoute'

type PageAnimatePresenceProps = {
  children: ReactNode
}

const PageAnimatePresence: FC<PageAnimatePresenceProps> = ({ children }) => {
  const pathname = usePathname()

  return (
    <AnimatePresence mode="wait">
      <motion.div key={pathname}>
        <FrozenRoute>{children}</FrozenRoute>
      </motion.div>
    </AnimatePresence>
  )
}

export default PageAnimatePresence
